import { Component, EventEmitter, Output, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Configuration, HttpClientCustom } from '../../shared';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { ConfirmationComponent } from '../../confirmation/confirmation';



@Component({
    selector: 'org',
    templateUrl: 'org.html',
    inputs: ['org'],
})
export class OrgComponent {
    // tslint:disable-next-line:member-access
    public org;
    public _baseUrl: any;
    public showChild: boolean = false;
    public hasChild: boolean = true;
    public asl: boolean = false;
    public result: any;
    public childOrgs;
    public answer: any;
    public orgTypeName: any;

    @Output() public deleteOrgEvent = new EventEmitter<number>();
    @Output() public editOrgEvent = new EventEmitter();
    @Output() public refresh = new EventEmitter();
    constructor(
        public _global: Configuration,
        public http: HttpClientCustom, public router: Router,
        public _toaster: ToasterComponent,
        public modalService: NgbModal,
        public activeModal: NgbActiveModal,
        public share: SharedData,
        public translate: TranslateService,
        vcr: ViewContainerRef) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
    }

    public hasChilds() {
        return this.org.childOrgs != null && this.org.childOrgs.length > 0;
    }

    public toggleChild() {
        let self = this;
        if (self.org.childOrgs) {
            self.showChild = !self.showChild;
        }
    }

    public getOrgtype() {
        if (!this.org.orgTypeName) {
            return this.share.getMapValues('' + this.org.orgType + '');
        } else {
            return this.org.orgTypeName;
        }

    }
    public addSubLevels(evn) {
        this.asl = evn;
    }

    public addChildTree(event: any) {
        if (!event.orgName.orgUnitTypeName) {
            this.orgTypeName = event.orgName;
        } else {
            this.orgTypeName = event.orgName.orgUnitTypeName;
        }
        this.share.saveAsMap('' + event.data.orgType + '', this.orgTypeName);
        if (this.org.childOrgs != null) {
            this.org.childOrgs.push(event.data);
        } else {
            this.org.childOrgs = new Array(0);
            this.org.childOrgs.push(event.data);
        }
        this.translate.get('orgSaved').subscribe((msg) => {
            this._toaster.showSuccess(msg);
        });

    }

    public closeSubLevels(evn) {
        this.asl = evn;
    }

    public deleteOrgModal() {
        this.share.saveData({ orgId: null, type: 'scaleRemove' });
        const modalRef = this.modalService.open(ConfirmationComponent,
            { windowClass: 'min-modal' }).result.then((result) => {
                if (result == 'confirmed') {
                    this.deleteOrg();
                }
            }, (reason) => {
                console.log(reason);
            });
    }

    public deleteOrg() {
        let self = this;
        let url = self._baseUrl + 'v1/webAdmin/orgUnit/' + self.org.id;
        self.http.delete(url).subscribe((result) => {
            if (result.success) {
                self.deleteOrgEvent.emit(self.org.id);
            } else {
                for (let val of result.errorMessages) {
                    self._toaster.showError(val);
                }
            }
        }, (error) => {
            this.translate.get('internalServerError').subscribe((msg) => {
                self._toaster.showError(msg);
            });
        });
    }

    public editOrg(param) {
        let self = this;
        self.editOrgEvent.emit(param);

    }

    public refreshLocal(param){
        this.refresh.emit("");
    }
}



// WEBPACK FOOTER //
// ./src/app/tools/org/org.ts